import React, { useState } from "react";
import styled from "styled-components";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import MainNavItem from "./MainNavItem";
import { NAV_ELEMENTS } from "constant/navigation";
import DotsLine from "components/common/view_util/DotsLine";
import MainNavigationSmallScreen from "./MainNavigationSmallScreen";
import GroupNavigation from "./GroupNavigation";
import MainNavGroup from "./MainNavGroup";
import UnitScanNavigation from "./UnitScanNavigation";
import { useIsGroupPage } from "hooks/citajteo/dl_group/useIsGroupPage";
import { useIsUnitPage } from "hooks/citajteo/dl_unit/useIsUnitPage";
import LinkTo from "../link/LinkTo";
import ModalLarge from "components/UI/modal/ModalLarge";
import SearchTextActivate from "../search/SearchTextActivate/SearchTextActivate";
import { useNavigate } from "react-router-dom";

type MainNavigationProps = {
  showMenu: boolean;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

const MainNavigation = ({ showMenu, setShowMenu }: MainNavigationProps) => {
  const navItemClickHandle = () => setShowMenu(false);
  const toggleMenu = () => setShowMenu((prev) => !prev);
  const isGroupPage = useIsGroupPage();
  const isUnitPage = useIsUnitPage();
  const [searchModalOpen, setSearchModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <>
      <MobileTopBar>
        <LogoWrapper>
          <LinkTo to={"/"}>
            <img src="/images/logo.png" alt="Logo" />
          </LinkTo>
        </LogoWrapper>

        <HamburgerWrapper>
          <MainNavigationSmallScreen
            showMenu={showMenu}
            navItemClickHandle={navItemClickHandle}
            menuShowClickHandle={toggleMenu}
          />
        </HamburgerWrapper>
      </MobileTopBar>

      <ContentWrapper>
        <Div>
          <img src="/images/logo.png" alt="Logo" />
          <HomeNavGroup>
            <MainNavItem navElement={NAV_ELEMENTS.HOME} />
            <SearchButton onClick={() => setSearchModalOpen(true)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </SearchButton>
            <ModalLarge
              open={searchModalOpen}
              onClose={() => setSearchModalOpen(false)}
              title="Pretraživanje"
            >
              <div>
                <SearchTextActivate
                  searchLabel=""
                  placeholder="Pretraživanje"
                  navigateToSearch={true}
                  defaultSearchText=""
                  onSearchActivate={() => setSearchModalOpen(false)}
                />
              </div>
            </ModalLarge>
          </HomeNavGroup>
          <DotsLine />
          {isGroupPage && <GroupNavigation />}
          {isUnitPage && <UnitScanNavigation />}
          <MainNavGroup>
            <MainNavItem navElement={NAV_ELEMENTS.ABOUT} />
            <MainNavItem navElement={NAV_ELEMENTS.COPYRIGHT} />
          </MainNavGroup>
          <DotsLine />
          <MainNavGroup>
            <MainNavItem navElement={NAV_ELEMENTS.ARTISTS} />
            <MainNavItem
              navElement={NAV_ELEMENTS.ART_MOVEMENTS_AND_PHENOMENA}
            />
            <MainNavItem navElement={NAV_ELEMENTS.MUZEJ_SAVREMENE_UMETNOSTI} />
          </MainNavGroup>
          <DotsLine />
        </Div>
      </ContentWrapper>
    </>
  );
};

const Div = styled.div`
  display: none;
  flex-direction: column;
  margin-top: 0;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: flex;
  }
`;

const MobileTopBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  width: 100vw;
  overflow-x: hidden;
  padding-top: 10px;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: none;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  width: 100%;

  img {
    margin-left: 1rem;
    height: 2.5rem;
  }
`;

const HamburgerWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
`;

const ContentWrapper = styled.div`
  @media (max-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: none;
  }
`;

const HomeNavGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;

  div {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const SearchButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    (props.theme && props.theme.color && props.theme.color.link) ?? "#a9a9a9"};
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #2a6496;
  }

  svg {
    width: 1.1rem;
    height: 1.1rem;
  }
`;

export default MainNavigation;
